import { io } from 'socket.io-client';

// Override with REACT_APP_SOCKET_URL in .env.local to point at a local backend.
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'https://api.play-sequence.com';

let socket;

export const getSocket = () => {
    if (!socket) {
        socket = io(SOCKET_URL, {
            transports: ['websocket', 'polling'],
            reconnection: true,
            reconnectionDelay: 500,
            reconnectionDelayMax: 5000
        });
    }
    return socket;
};

/**
 * Sends a command and resolves with the server's acknowledgement payload, or
 * rejects with the server's error message. Commands mutate; the resulting state
 * arrives for everyone through the `game:update` broadcast.
 */
export const emitCommand = (event, payload) => new Promise((resolve, reject) => {
    getSocket().timeout(10000).emit(event, payload, (timeoutError, response) => {
        if (timeoutError) {
            reject(new Error('The server took too long to respond'));
            return;
        }
        if (!response || response.ok !== true) {
            reject(new Error(response?.message || 'Something went wrong'));
            return;
        }
        resolve(response.data);
    });
});
